export default __webpack_public_path__ + "static/media/startupGifts.ec3c7cbe.png";